module.exports = __webpack_public_path__ + "static/assets/e73c0e5cc490e00662ac2178d3098930.png";